import { useLoaderData } from "react-router-dom"
import SideDrawer from "../SideDrawer/SideDrawer"



export const PowerBiReports = () => {
  const options = useLoaderData()
  return (
    <>
      <SideDrawer options={ options.filter( opt => opt.id !== 'kpi' ) } />
    </>
  )
}